"use client";
import { useEffect, useState } from "react";
import { IMAGES } from "@/lib/constants";
import Image from "next/image";
import { useCreditScoreQuery } from "@/lib/redux"
import {
  Box,
  Card,
  Typography,
  Chip,
  Stack,
  Divider } from "@mui/material";
import { useFooter } from "@/lib/context/FooterContext";
import HeroLoaderComponent from "@/components/HeroLoader";
import useLogoutHook from "@/lib/hooks/logoutHook";
import styles from "../checkeligibility.module.css";
import {
  useCreditDashboardDataLastQuery, useCreditScoreDashboardDataLatestMutation, useGetPanDetailsQuery
} from "@/lib/redux";
import { SnackbarComponent } from "@/components";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { CheckIcon } from "lucide-react";
import StarIcon from "@mui/icons-material/Star";

const CheckEligibilityDashboard = ({ name = "Tushar", amount = "5,00,000" }) => {
  const { setActions } = useFooter();
  const [step, setStep] = useState("scale");
  const [storeData, setStoreData] = useState(null);
  const { handleLogout } = useLogoutHook();
  // const { data, isLoading, isError, error } = useCreditDashboardDataLastQuery();
  //const finalData = data;

// useEffect(() => {
//   if (error) {
//     SnackbarComponent({
//       error: true,
//       errorMessage: error?.data?.message || "Something went wrong. Please try again later.",
//     });
//     handleLogout();
//   }
// }, [error]);

  useEffect(() => {
     setActions({
       showReject: false,
       showConfirm: true,
     });
   }, [setActions]);

//  if (isLoading) {
//     return <HeroLoaderComponent open={true} loadingLabel={"Please wait for a moment..."} />; 
//   }
  return (

    <div className={styles["parent-container"]}>
      <Card
        sx={{
          // p: 4,
          borderRadius: "24px",
          backgroundColor:"#f8fafa",
        }}
      >
        {/* Top Section */}
        <Stack direction="row" justifyContent="space-between">
          <Box sx={{
              p: 4,
            }}>
            <Typography variant="h4" fontWeight={700}>
              Congratulations {name} !
            </Typography>

            <Typography color="text.secondary" mt={1}>
              You’re <b>eligible</b> for a personal loan upto
            </Typography>

            <Typography
              variant="h3"
              fontWeight={800}
              mt={2}
              color="success.dark"
            >
              ₹ {amount}
            </Typography>

              <Box
                  sx={{
                    mt: 2,
                    px: 2.5,
                    py: 1,
                    borderRadius: "14px",
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,

                    background: `
                      linear-gradient(
                        to right,
                        #E6F4EA 0%,
                        #E6F4EA 70%,
                        rgba(230, 244, 234, 0.4) 85%,
                        rgba(230, 244, 234, 0) 100%
                      )
                    `,
                  }}
                >
              <StarIcon
                sx={{
                  color: "#F4A261", // soft orange star
                  fontSize: 20,
                }}
              />

              <Typography
                sx={{
                  fontStyle: "italic",
                  fontSize: "14.5px",
                  color: "#1E4D3B",
                }}
              >
                Complete the next step to unlock this amount and get final loan approval
              </Typography>
            </Box>
          </Box>

          {/* Right Badge */}
          <Box
            sx={{
               width: 50,
               height: 50,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Image
              src={IMAGES.starIcon}
              style={{
                transform: "scale(0.5)",
                marginTop:"200px",
                marginRight:"140px",
              }}
              alt="Star Icon"
            />
          </Box>
        </Stack>

        {/* Trust Bar */}
        <Box
          sx={{
            mt: 4,
            px: { xs: 2, sm: 4 },
            py: 2,
            // borderRadius: "16px",
            backgroundColor: "#EAF5F1",
          }}
        >
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            {[
              "Trusted by 20Mn+ Happy Customers",
              "100% Digital process",
              "Loan disbursed in every 30 seconds",
            ].map((text) => (
              <Stack
                key={text}
                direction="row"
                spacing={1}
                alignItems="center"
              >
              <Box
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    backgroundColor: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CheckIcon
                    sx={{
                      color: "#0B3D2E", // dark green / almost black
                      fontSize: 15,
                      fontWeight: 500,
                    }}
                  />
                </Box>
                <Typography fontWeight={500}>{text}</Typography>
              </Stack>
            ))}
          </Stack>
        </Box>
      </Card>
      {/* Info Box */}
      <Box
        sx={{
          mt: 4,
          p: 2,
          borderRadius: "12px",
          backgroundColor: "#fffae9",
          border: "1px solid #FFE082",
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <InfoOutlinedIcon color="warning" />
          <Typography fontWeight={600}>Important Information</Typography>
        </Stack>

        <Typography mt={1} color="text.secondary">
          This is preliminary eligibility based on the details provided. Final
          approval is subject to further checks.
        </Typography>
      </Box>
     
    </div>
    
  );
};

export default CheckEligibilityDashboard;
